import Regions from "@/store/data/regions.json";

export type Region = {
  id: string;
  name: string;
  languages: string[];
};

export function findRegion(id: string): Region | undefined {
  return Regions.find((r) => r.id === id);
}

export function isValidRegion(id: string | undefined): boolean {
  return !!id && findRegion(id) !== undefined;
}

export function getDefaultLanguage(regionId: string): string | undefined {
  return findRegion(regionId)?.languages[0];
}
